/** "Email doesn't arrive" — SendGrid's last word on this address (migration 626). */
export function UndeliverableBadge({ at, reason }: { at: string; reason?: string | null }) {
    const when = new Date(at).toLocaleDateString("en-US", { month: "short", day: "numeric" });
    return (
        <span
            className="shrink-0 rounded border border-destructive/40 bg-destructive/10 px-1.5 py-0.5 text-[10px] font-semibold text-destructive"
            title={`${reason ?? "Our email didn't arrive"} (${when}). Fix the address — changing it clears this.`}
            data-testid="undeliverable-badge"
        >
            Bounced {when}
        </span>
    );
}
